// hyphen '‐' '\u2010'; | hyphen_minus '-' '\u002D'; | minus '−' '\u2212'; | dash '–' '\u2013';

export enum DefaultSettings {
  MIN_LENGTH_PASSWORD = 6,
  MIN_VALUE = 1,
  MIN_LENGTH_POST_CODE = 4,
  PATTERN_VAT = 'BE0123.123.123',
  PATTERN_PHONE = '03/457.34.90',
  PATTERN_MOBILE_PHONE = '0499/12.42.15',
  STREET_NAME_REGEX = '.*[a-zA-Z]+.*',
  POSTAL_CODE_NL = '^([1-9]\\d{3})\\s{0,1}([A-Z]{2})$',
  POSTAL_CODE_BE = '^[1-9]{1}[0-9]{3}$',
  POSTAL_CODE_DE_FR = '^[0-9]{5}$',
  POSTAL_CODE_UK = '^[A-Z]{1,2}[0-9R][0-9A-Z]? [0-9][ABD-HJLNP-UW-Z]{2}$',
  HOUSE_NUMBER_NL = '^\\d{1,5}(\\s?[-–]{1}\\s?\\d{1,5})?$',
  HOUSE_NUMBER_NL_ALPHA = '^[A-Z]{1}\\d{3}(\\s?[-–]{1}\\s?\\d{3})?$',
  MAX_LENGTH_TEXT_AREA = 280,
  STREET_BE_LU_REGEXP = "^[a-zA-ZÀ-Ÿ'&.\\s-–‐−]+$",
  HOUSE_NUMBER_BE_LU_REGEXP = '^[a-zA-Z0-9-/–‐−]+$',
  HOUSE_NUMBER_ADDITION_BE_LU_REGEXP = '^[a-zA-Z0-9]+$',
  PEPPOL_ID_REGEX = '^[0-9]{4}:[^\\s]+$',
}
